export const ENSILATION_TYPE_LOADING = 'ENSILATION_TYPE_LOADING';
export const ENSILATION_TYPE_ERROR = 'ENSILATION_TYPE_ERROR';
export const ENSILATION_TYPE_SUCCESS = 'ENSILATION_TYPE_SUCCESS';